import { render, staticRenderFns } from "./ModalLogs.vue?vue&type=template&id=6137459f&scoped=true&lang=pug&"
import script from "./ModalLogs.vue?vue&type=script&lang=js&"
export * from "./ModalLogs.vue?vue&type=script&lang=js&"
import style0 from "./ModalLogs.vue?vue&type=style&index=0&id=6137459f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137459f",
  null
  
)

export default component.exports